var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 10H8.66732V11.3334H7.33398V10ZM7.33398 4.66671H8.66732V8.66671H7.33398V4.66671ZM7.99398 1.33337C4.31398 1.33337 1.33398 4.32004 1.33398 8.00004C1.33398 11.68 4.31398 14.6667 7.99398 14.6667C11.6807 14.6667 14.6673 11.68 14.6673 8.00004C14.6673 4.32004 11.6807 1.33337 7.99398 1.33337ZM8.00065 13.3334C5.05398 13.3334 2.66732 10.9467 2.66732 8.00004C2.66732 5.05337 5.05398 2.66671 8.00065 2.66671C10.9473 2.66671 13.334 5.05337 13.334 8.00004C13.334 10.9467 10.9473 13.3334 8.00065 13.3334Z",
    fill: "#FF4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ce5f7393ce191aac8bd1419f400ab823.svg";
export { ForwardRef as ReactComponent };